import logo from "../assets/logo.svg";
import s1 from "../assets/icons/s1.svg";
import s2 from "../assets/icons/s2.svg";
import s3 from "../assets/icons/s3.svg";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { CategoriesData } from "src/data/categories";
import { Link } from "react-router-dom";


export default function Footer() {

  return (
    <div>
      <div className="pt-16 pb-12 bg-[#515151] border-t border-white/10 px-[5%] text-white">
        <div className="mx-auto max-w-[1400px] flex flex-col md:flex-row md:justify-between md:gap-x-12 lg:gap-x-20">
          <div className="flex flex-col items-center md:items-start justify-start gap-y-6 md:w-56 mb-8 md:mb-0 flex-shrink-0">
            <img src={logo} alt="MDI Logo" className="h-12 w-auto object-contain select-none"></img>
            <div className="flex gap-4">
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-neutral-900/80 border border-white/10 hover:bg-[#0065AD] hover:border-transparent flex items-center justify-center transition-all duration-300 transform hover:-translate-y-1 hover:shadow-[0_0_15px_rgba(0,101,173,0.4)]"
                aria-label="Social Link 1"
              >
                <img src={s2} alt="" className="w-4 h-4 object-contain brightness-0 invert opacity-90 hover:opacity-100 transition-opacity" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-neutral-900/80 border border-white/10 hover:bg-[#0065AD] hover:border-transparent flex items-center justify-center transition-all duration-300 transform hover:-translate-y-1 hover:shadow-[0_0_15px_rgba(0,101,173,0.4)]"
                aria-label="Social Link 2"
              >
                <img src={s3} alt="" className="w-4 h-4 object-contain brightness-0 invert opacity-90 hover:opacity-100 transition-opacity" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-neutral-900/80 border border-white/10 hover:bg-[#0065AD] hover:border-transparent flex items-center justify-center transition-all duration-300 transform hover:-translate-y-1 hover:shadow-[0_0_15px_rgba(0,101,173,0.4)]"
                aria-label="Social Link 3"
              >
                <img src={s1} alt="" className="w-4 h-4 object-contain brightness-0 invert opacity-90 hover:opacity-100 transition-opacity" />
              </a>
            </div>
          </div>

          <div className="md:hidden pb-10 w-full">
            <Accordion type="single" collapsible className="w-full space-y-1">
              {CategoriesData.map((category, index) => (
                <AccordionItem key={index} value={`item-${index}`} className="border-white/10">
                  <AccordionTrigger className="text-white hover:text-neutral-100 text-sm font-semibold py-4 hover:no-underline uppercase">
                    {category.category}
                  </AccordionTrigger>
                  <AccordionContent className="pb-4">
                    <ul className="text-xs space-y-2.5">
                      {category.subcategories.map((subcategory, indexSub) => (
                        <li key={indexSub} className="transition-all duration-300 transform hover:translate-x-1">
                          <Link
                            to={"/ourProducts/" + category.id + "/" + subcategory.name.toLocaleLowerCase()}
                            className="text-neutral-200 hover:text-white transition-colors duration-200 block py-1"
                          >
                            {subcategory.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </AccordionContent>
                </AccordionItem>
              ))}

              <AccordionItem value="item-directory" className="border-white/10">
                <AccordionTrigger className="text-white hover:text-neutral-100 text-sm font-semibold py-4 hover:no-underline uppercase">
                  DIRECTORY
                </AccordionTrigger>
                <AccordionContent className="pb-4">
                  <ul className="text-xs space-y-2.5">
                    {["EL SALVADOR", "BELIZE", "PANAMÁ", "GUATEMALA", "HONDURAS", "COSTA RICA", "NICARAGUA"].map((country, idx) => (
                      <li key={idx} className="text-neutral-200 hover:text-white transition-colors duration-200 py-1">
                        {country}
                      </li>
                    ))}
                  </ul>
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-company" className="border-white/10">
                <AccordionTrigger className="text-white hover:text-neutral-100 text-sm font-semibold py-4 hover:no-underline uppercase">
                  COMPANY
                </AccordionTrigger>
                <AccordionContent className="pb-4">
                  <ul className="text-xs space-y-2.5">
                    <li>
                      <Link to="/aboutUs" className="text-neutral-200 hover:text-white transition-colors duration-200 block py-1">
                        ABOUT US
                      </Link>
                    </li>
                    <li>
                      <Link to="/ourProducts" className="text-neutral-200 hover:text-white transition-colors duration-200 block py-1">
                        OUR BRANDS
                      </Link>
                    </li>
                    <li>
                      <Link to="/contactUs" className="text-neutral-200 hover:text-white transition-colors duration-200 block py-1">
                        CONTACT US
                      </Link>
                    </li>
                  </ul>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>

          <div className="hidden md:flex md:flex-row md:flex-wrap lg:flex-nowrap justify-between gap-x-6 gap-y-10 pb-10 flex-grow">
            {CategoriesData.slice(0, 1).map((category, index: number) => (
              <div key={index} className="uppercase flex-1 min-w-[120px]">
                <div>
                  <h3 className="font-bold mb-4 text-white text-sm tracking-wider uppercase select-none">
                    {category.category}
                    <div className="h-[2px] w-6 bg-white mt-1.5 rounded-full opacity-80"></div>
                  </h3>
                  <ul className="text-xs space-y-2.5">
                    {category.subcategories.map((subcategory, indexSub: number) => (
                      <li key={indexSub} className="transition-all duration-300 transform hover:translate-x-1">
                        <Link
                          to={
                            "/ourProducts/" +
                            category.id +
                            "/" +
                            subcategory.name.toLocaleLowerCase()
                          }
                          className="text-neutral-200 hover:text-white transition-colors duration-200"
                        >
                          {subcategory.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}

            <div className="flex flex-col gap-y-8 uppercase flex-1 min-w-[120px]">
              {CategoriesData.slice(
                1,
                Math.ceil(CategoriesData.length / 2)
              ).map((category, index: number) => (
                <div key={index}>
                  <h3 className="font-bold mb-4 text-white text-sm tracking-wider uppercase select-none">
                    {category.category}
                    <div className="h-[2px] w-6 bg-white mt-1.5 rounded-full opacity-80"></div>
                  </h3>
                  <ul className="text-xs space-y-2.5">
                    {category.subcategories.map((subcategory, indexsubCat) => (
                      <li key={indexsubCat} className="transition-all duration-300 transform hover:translate-x-1">
                        <Link
                          to={"/ourProducts/" + category.id + "/" + subcategory.name.toLocaleLowerCase()}
                          className="text-neutral-200 hover:text-white transition-colors duration-200"
                        >
                          {subcategory.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
            <div className="flex flex-col gap-y-8 uppercase flex-1 min-w-[120px]">
              {CategoriesData.slice(Math.ceil(CategoriesData.length / 2)).map(
                (category, index: number) => (
                  <div key={index}>
                    <h3 className="font-bold mb-4 text-white text-sm tracking-wider uppercase select-none">
                      {category.category}
                      <div className="h-[2px] w-6 bg-white mt-1.5 rounded-full opacity-80"></div>
                    </h3>
                    <ul className="text-xs space-y-2.5">
                      {category.subcategories.map(
                        (subcategory, indexsubCat) => (
                          <li key={indexsubCat} className="transition-all duration-300 transform hover:translate-x-1">
                            <Link
                              to={"/ourProducts/" + category.id + "/" + subcategory.name.toLocaleLowerCase()}
                              className="text-neutral-200 hover:text-white transition-colors duration-200"
                            >
                              {subcategory.name}
                            </Link>
                          </li>
                        )
                      )}
                    </ul>
                  </div>
                )
              )}
            </div>

            <div className="flex-1 min-w-[120px]">
              <h3 className="font-bold mb-4 text-white text-sm tracking-wider uppercase select-none">
                DIRECTORY
                <div className="h-[2px] w-6 bg-white mt-1.5 rounded-full opacity-80"></div>
              </h3>
              <ul className="text-xs space-y-2.5">
                {["EL SALVADOR", "BELIZE", "PANAMÁ", "GUATEMALA", "HONDURAS", "COSTA RICA", "NICARAGUA"].map((country, idx) => (
                  <li key={idx} className="text-neutral-200 hover:text-white transition-colors hover:translate-x-1 transform duration-300 select-none">
                    {country}
                  </li>
                ))}
              </ul>
            </div>

            <div className="flex-1 min-w-[120px]">
              <h3 className="font-bold mb-4 text-white text-sm tracking-wider uppercase select-none">
                COMPANY
                <div className="h-[2px] w-6 bg-white mt-1.5 rounded-full opacity-80"></div>
              </h3>
              <ul className="text-xs space-y-2.5">
                <li className="transition-all duration-300 transform hover:translate-x-1">
                  <Link to={"/aboutUs"} className="text-neutral-200 hover:text-white transition-colors duration-200">
                    ABOUT US
                  </Link>
                </li>
                <li className="transition-all duration-300 transform hover:translate-x-1">
                  <Link to={"/ourProducts"} className="text-neutral-200 hover:text-white transition-colors duration-200">
                    OUR BRANDS
                  </Link>
                </li>
                <li className="transition-all duration-300 transform hover:translate-x-1">
                  <Link to={"/contactUs"} className="text-neutral-200 hover:text-white transition-colors duration-200">
                    CONTACT US
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-black text-neutral-300 px-[5%] text-center text-xs py-6 select-none font-medium tracking-wide">
        Copyright © {new Date().getFullYear()} All rights reserved by ♥{" "}
        <a className="text-white hover:text-[#0065AD] underline transition-colors duration-200" href="https://thetecwave.com/" target="_blank" rel="noopener noreferrer">
          TECWAVE
        </a>
      </div>
    </div>
  );
}
